export default "__VITE_ASSET__S7L6VmzE__"